<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaPerfil"
      option-label="display_name"
      option-value="id"
      label="Selecione o Perfil"
      :bg-color="disable ? 'grey-3' : ''"
      :disable="disable"
      label-color="grey-6"
      behavior="menu"
      map-options
      hide-bottom-space
      :able-colspan="12"
      :stack-label="true"
      use-input
      :rules="validacao ? [(val) => val || 'Campo Obrigatório'] : []"
      @filter="filtrar"
      :display-value="
        modelValue?.display_name?.length > 9
          ? `${modelValue?.display_name?.substring(0, 9)}....`
          : modelValue?.display_name
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="modelValue">
        {{ props.modelValue?.display_name }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
  disable: {
    type: Boolean,
  },
  validacao: {
    type: Boolean,
    default: false,
  },
});

const listaPerfil = ref([]);

const listarPerfis = async (val) => {
  listaPerfil.value = [];
  try {
    let response = await store.dispatch("user/getRoles");
    if (
      store.state.autenticacao.cliente.includes("staging-multpex") ||
      store.state.autenticacao.cliente.includes("multpex")
    ) {
      listaPerfil.value = response.data.results.data;

      listaPerfil.value = listaPerfil.value.filter(
        (v) => v.display_name.toLowerCase().indexOf(val.toLowerCase()) > -1
      );
      return;
    }
    listaPerfil.value = response.data.results.data.filter((value) => {
      if (value.name != "admin" && value.name != "tablet") {
        return value.display_name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

const filtrar = async (val, update) => {
  await listarPerfis(val);
  update();
};
</script>

<style scoped>
.q-field {
  overflow: hidden;
  white-space: no-wrap;
}
</style>
